module.exports = __webpack_public_path__ + "img/apriori.e6679f59.png";